import { render, staticRenderFns } from "./ReporteCorreo.vue?vue&type=template&id=215257c6&"
import script from "./ReporteCorreo.vue?vue&type=script&lang=js&"
export * from "./ReporteCorreo.vue?vue&type=script&lang=js&"
import style0 from "./ReporteCorreo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports